import {useEffect, useState} from "react";

const SEARCH_DEBOUNCE_MS = 500;

export interface ReservationRailSearchController {
    query: string;
    setQuery: (query: string) => void;
    debouncedQuery: string;
}

export function useReservationRailSearch(): ReservationRailSearchController {
    const [query, setQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");

    useEffect(() => {
        const trimmedQuery = query.trim();
        if (!trimmedQuery) {
            setDebouncedQuery("");
            return;
        }

        const timeout = window.setTimeout(() => {
            setDebouncedQuery(trimmedQuery);
        }, SEARCH_DEBOUNCE_MS);

        return () => window.clearTimeout(timeout);
    }, [query]);

    return {
        query,
        setQuery,
        debouncedQuery,
    };
}
